import { useCallback } from 'react';

import { UpdateError } from './useUploadCsv';

export const useHasUpdateError = (csvUpdateErrors: UpdateError[] | null) => {
  const hasUpdateError = useCallback<(userId: number) => boolean>(
    (userId) => {
      if (!csvUpdateErrors) {
        return false;
      }

      return csvUpdateErrors.map((o) => o.rowNo).includes(userId);
    },
    [csvUpdateErrors],
  );

  return { hasUpdateError };
};
